import createIcon from '../../createIcon';

/**
 * @component @name ModeFanOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNjQ1MyA4LjA1NTMxTDE0LjM1NTMgOC44NzUzMUMxNC4xNzUzIDguNzQ1MzEgMTMuOTc1MyA4LjYyNTMxIDEzLjc3NTMgOC41MzUzMUMxMy45NDUzIDcuNzA1MzEgMTQuNDA1MyA2Ljk1NTMxIDE1LjEzNTMgNi40NzUzMUMxNy4xNTUzIDUuMTM1MzEgMTYuNDg1MyAxLjY5NTMxIDEzLjY5NTMgMS42OTUzMUMxMC42MTUzIDEuNjk1MzEgOC43OTUzMSAzLjE2NTMxIDguMzk1MzEgNC45NTUzMUwxOS4wMzUzIDE1LjU5NTNDMjAuNTM1MyAxNS45ODUzIDIyLjMwNTMgMTUuMDg1MyAyMi4zMDUzIDEzLjA4NTNDMjIuMzA1MyA4LjY5NTMxIDE5LjI5NTMgNi44NTUzMSAxNi42NDUzIDguMDU1MzFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy4xMTUzMSAyLjUwNTMxTDEuNjk1MzEgMy45MTUzMUw1LjU3NTMxIDcuNzk1MzFDNC4wNzUzMSA3LjM5NTMxIDIuMzA1MzEgOC4zMDUzMSAyLjMwNTMxIDEwLjMwNTNDMi4zMDUzMSAxNC43MDUzIDUuMzE1MzEgMTYuNTQ1MyA3Ljk2NTMxIDE1LjMzNTNMMTAuMjU1MyAxNC41MTUzQzEwLjQzNTMgMTQuNjQ1MyAxMC42MzUzIDE0Ljc2NTMgMTAuODM1MyAxNC44NTUzQzEwLjY2NTMgMTUuNjg1MyAxMC4yMDUzIDE2LjQzNTMgOS40NzUzMSAxNi45MTUzQzcuNDU1MzEgMTguMjU1MyA4LjEyNTMxIDIxLjY5NTMgMTAuOTE1MyAyMS42OTUzQzEzLjk5NTMgMjEuNjk1MyAxNS44MTUzIDIwLjIyNTMgMTYuMjE1MyAxOC40MzUzTDIwLjA4NTMgMjIuMzA1M0wyMS40OTUzIDIwLjg5NTNMMy4xMTUzMSAyLjUwNTMxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeFanOff = createIcon('ModeFanOff', [
  [
    'path',
    {
      d: 'M16.6453 8.05531L14.3553 8.87531C14.1753 8.74531 13.9753 8.62531 13.7753 8.53531C13.9453 7.70531 14.4053 6.95531 15.1353 6.47531C17.1553 5.13531 16.4853 1.69531 13.6953 1.69531C10.6153 1.69531 8.79531 3.16531 8.39531 4.95531L19.0353 15.5953C20.5353 15.9853 22.3053 15.0853 22.3053 13.0853C22.3053 8.69531 19.2953 6.85531 16.6453 8.05531Z',
      key: 'rfbyam',
    },
  ],
  [
    'path',
    {
      d: 'M3.11531 2.50531L1.69531 3.91531L5.57531 7.79531C4.07531 7.39531 2.30531 8.30531 2.30531 10.3053C2.30531 14.7053 5.31531 16.5453 7.96531 15.3353L10.2553 14.5153C10.4353 14.6453 10.6353 14.7653 10.8353 14.8553C10.6653 15.6853 10.2053 16.4353 9.47531 16.9153C7.45531 18.2553 8.12531 21.6953 10.9153 21.6953C13.9953 21.6953 15.8153 20.2253 16.2153 18.4353L20.0853 22.3053L21.4953 20.8953L3.11531 2.50531Z',
      key: '162d07',
    },
  ],
]);

export default ModeFanOff;
